enum Scope {
  Business = 'Business',
  GTM = 'GTM',
  Debug = 'Debug'
}

export enum UserProperty {
  TaurineVersion = 'TaurineVersion',
  IsMobile = 'IsMobile',
  Viewport = 'Viewport',
  ViewportHeight = 'ViewportHeight',
  ViewportWidthXHeight = 'ViewportWidthXHeight',
  DebtorCount = 'DebtorCount',
  Origin = 'Origin',
  ConfigurationID = 'ConfigurationID',
  AdvertisementID = 'AdvertisementID',
  TaurineConfiguration = 'TaurineConfiguration',
  EntryPointInitial = 'EntryPointInitial',
  EntryPointPageName = 'EntryPointPageName',
  EntryPointParent = 'EntryPointParent',
  NetworkType = 'NetworkType',
  ActivityID = 'ActivityID',
  ClientID = 'ClientID',
  AffiliateID = 'AffiliateID',
  PlacementID = 'PlacementID',
  OptimizelyEndUserId = 'OptimizelyEndUserId',
  OptimizelyVariation = 'OptimizelyVariation',
  OptimizelyUserAttributes = 'OptimizelyUserAttributes',
  OptimizelyExperimentName = 'OptimizelyExperimentName',
  BackUrl = 'BackUrl',
  Tenant = 'tenant',
  UtmMedium = 'utmMedium',
  UtmParameters = 'utmParameters',
  UtmCampaign = 'utmCampaign',
  UtmSource = 'utmSource',
  FcId = 'fcId'
}

export enum EventProperty {
  CurrentPage = 'currentPage',
  TraversalId = 'traversalId',
  LastInputTouched = 'lastInputTouched',
  NextInputUntouched = 'nextInputUntouched'
}

// please update the Confluence page when adding a new event
// https://confluence.atl.finanzcheck.de/display/CAT/Amplitude+Events+RR
export enum AmplitudeEvent {
  LogExecutionTime = 'LogExecutionTime',
  LogDependencyTimeout = 'LogDependencyTimeout',
  VisitPage = 'VisitPage',
  ViewPage = 'ViewPage',
  GenerateLead = 'GenerateLead',
  GoToFinal = 'GoToFinal',
  InteractWithField = 'InteractWithField',
  ToggleInformation = 'ToggleInformation',
  ValidateTraversal = 'ValidateTraversal',
  ConditionalFields = 'ConditionalFields',
  AddSecondDebtorClicked = 'AddSecondDebtorClicked',
  AddSecondDebtorSeen = 'AddSecondDebtorSeen',
  RefinancingCalculatorOpen = 'RefinancingCalculatorOpen',
  RefinancingCalculatorSavingsChange = 'RefinancingCalculatorSavingsChange',
  UseSaveButton = 'UseSaveButton',
  DisplayBestOfferBox = 'DisplayBestOfferBox',
  UseCompanyAutocomplete = 'UseCompanyAutocomplete',
  ChangeTabVisibility = 'ChangeTabVisibility',
  DetectAbort = 'DetectAbort',
  UseHotlineFallback = 'UseHotlineFallback',
  ShowHotlineFallback = 'ShowHotlineFallback',
  VisitSealUrl = 'VisitSealUrl',
  AlertSamePayoutAccountUsed = 'AlertSamePayoutAccountUsed',
  ShowConstructionFinancingNotice = 'ShowConstructionFinancingNotice',
  CtaIsVisible = 'CtaIsVisible',
  CtaIsClicked = 'CtaIsClicked',
  BackLinkIsClicked = 'BackLinkIsClicked',
  BackButtonIsClicked = 'BackButtonIsClicked',
  ErrorPageShown = 'ErrorPageShown',
  ErrorOccurred = 'ErrorOccured',
  OnDACSuccessAutoRedirect = 'fintec_dacSuccessAutoRedirect',
  OnDACWithoutClick = 'fintec_withoutDacClick',
  OnDacAccordionClick = 'fintec_accordion_click',
  OnDacWrapperView = 'fintec_dacWrapper_viewed',
  OnDacStateChange = 'fintec_onStateChange',
  OnDacSuccess = 'fintec_onSuccess',
  OnDacError = 'fintec_onError',
  OnDacAbort = 'fintec_onAbort',
  OnDacStepViewAccessConfirmation = 'fintec_stepView_accessConfirmation',
  OnDacStepViewRegistrationSuccessful = 'fintec_stepView_registrationSuccessful',
  OnDacTranscationalIdNull = 'OnDacTranscationalIdNull',
  OnLoginClicked = 'OnLoginClicked',
  OnTaurineStartsLoading = 'OnTaurineStartsLoading',
  OnTaurineBecomesUsable = 'OnTaurineBecomesUsable',
  ParentFrameStartLoadTime = 'ParentFrameStartLoadTime',
  FinalAfterInactivityAfterEnteringPayoutAccount = 'FinalAfterInactivityAfterEnteringPayoutAccount',
  FinalAfterInactivityAfterDACInitialization = 'FinalAfterInactivityAfterDACInitialization',
  FinalAfterInactivityAfterDACChoice = 'FinalAfterInactivityAfterDACChoice',
  IbanValidated = 'IbanValidated',
  AccountNumberValidated = 'AccountNumberValidated',
  BankCodeValidated = 'BankCodeValidated',
  RemainingAmountErrorShown = 'RemainingAmountErrorShown',
  OnNewsletterConsentLinkClicked = 'OnNewsletterConsentLinkClicked',
  OnBedingungenClickedInVoucher = 'OnBedingungenClickedInVoucher',
  TopNotActivatedVoucherBannerClicked = 'TopNotActivatedVoucherBannerClicked',
  BrandSource = 'BrandSource',
  PreviousPageErrorNavigationShown = 'PreviousPageErrorNavigationShown',
  PreviousPageErrorNavigationClicked = 'PreviousPageErrorNavigationClicked',
  RceEditUpdateDataClicked = 'RceEditUpdateDataClicked',
  TplManuallyAdaptedAmountRelation = 'TplManuallyAdaptedAmountRelation',
  Tpl3AmountRelation = 'Tpl3AmountRelation',
  ResumeHashConsumed = 'ResumeHashConsumed',
  CaptchaWidgetLoaded = 'CaptchaWidgetLoaded',
  CaptchaInitiated = 'CaptchaInitiated',
  CaptchaSkipped = 'CaptchaSkipped',
  CaptchaAlreadyInProgress = 'CaptchaAlreadyInProgress',
  CaptchaGetStatus = 'CaptchaGetStatus',
  CaptchaStatusIsValid = 'CaptchaStatusIsValid',
  CaptchaGetStatusError = 'CaptchaGetStatusError',
  CaptchaExecute = 'CaptchaExecute',
  CaptchaExecuteSuccess = 'CaptchaExecuteSuccess',
  CaptchaExecuteError = 'CaptchaExecuteError',
  CaptchaChallengeStarted = 'CaptchaChallengeStarted',
  CaptchaChallengeSuccess = 'CaptchaChallengeSuccess',
  CaptchaPostToken = 'CaptchaPostToken',
  CaptchaPostTokenSuccess = 'CaptchaPostTokenSuccess',
  CaptchaPostTokenError = 'CaptchaPostTokenError',
  CaptchaUnsupported = 'CaptchaUnsupported',
  CaptchaError = 'CaptchaError',
  CaptchaSuccess = 'CaptchaSuccess',
  CaptchaExpired = 'CaptchaExpired',
  CaptchaTimeout = 'CaptchaTimeout',
  CaptchaAborted = 'CaptchaAborted',
  CaptchaBeforeInteractive = 'CaptchaBeforeInteractive',
  CaptchaAfterInteractive = 'CaptchaAfterInteractive',
  CaptchaKillSwitchIsActive = 'CaptchaKillSwitchIsActive',
  CaptchaTimeoutError = 'CaptchaTimeoutError',
  NudgeIsVisible = 'NudgeIsVisible',
  DesiredPayoutTime = 'DesiredPayoutTime',
  AgeGroup = 'AgeGroup',
  IncomeSetSuccessfully = 'IncomeSetSuccessfully',
  StartDacButtonClicked = 'StartDacButtonClicked',
  MoreInfoDacClicked = 'MoreInfoDacClicked',
  ValidationErrorOccured = 'ValidationErrorOccured',
  // RCE Edit page – field change tracking
  RceEditStreetChanged = 'RceEditStreetChanged',
  RceEditStreetNumberChanged = 'RceEditStreetNumberChanged',
  RceEditIbanChanged = 'RceEditIbanChanged',
  RceEditAmountChanged = 'RceEditAmountChanged',
  RceEditIncomeChanged = 'RceEditIncomeChanged',
  RceEditPensionChanged = 'RceEditPensionChanged',

  // Voucher campaign events
  AddToVoucherCampaign = 'AddToVoucherCampaign',
  RequestedAmountBetween20k50k = 'RequestedAmountBetween20k50k',
  RequestedAmountBetween30k50k = 'RequestedAmountBetween30k50k',
  RequestedAmountOver50k = 'RequestedAmountOver50k',

  //Multiple citizenship tracking
  AddedAdditionalNationality = 'AddedAdditionalNationality',
  RemovedAdditionalNationalities = 'RemovedAdditionalNationalities',
  IsMultipleCitizenshipAddedOnFinal = 'IsMultipleCitizenshipAddedOnFinal',

  // Field reset diagnostics
  FieldResetOnError = 'FieldResetOnError',

  // CAT-4853 document delivery fake door
  DocumentDeliveryOptionMissing = 'DocumentDeliveryOptionMissing',
  DocumentDeliveryChangeLinkClicked = 'DocumentDeliveryChangeLinkClicked',
  DocumentDeliveryChoiceMissing = 'DocumentDeliveryChoiceMissing',
  DocumentDeliverySelection = 'DocumentDeliverySelection'
}

export enum InformationElement {
  Tooltip = 'tooltip',
  IntroText = 'introText'
}

export enum AutocompleteEventType {
  ReceivedResults = 'ReceivedResults',
  NoResults = 'NoResults',
  SelectResult = 'SelectResult'
}

export enum ErrorType {
  Field = 'field',
  Page = 'page'
}

export enum FinalRedirectStatus {
  Succeeded = 'succeeded',
  Failed = 'failed'
}

const scope: Record<AmplitudeEvent, Scope[]> = {
  [AmplitudeEvent.LogExecutionTime]: [Scope.Debug],
  [AmplitudeEvent.LogDependencyTimeout]: [Scope.Debug],
  [AmplitudeEvent.VisitPage]: [Scope.Business, Scope.GTM],
  [AmplitudeEvent.ViewPage]: [Scope.Business, Scope.GTM],
  [AmplitudeEvent.GenerateLead]: [Scope.Business, Scope.GTM],
  [AmplitudeEvent.GoToFinal]: [Scope.Business, Scope.GTM, Scope.Debug],
  [AmplitudeEvent.InteractWithField]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ToggleInformation]: [Scope.Business],
  [AmplitudeEvent.ValidateTraversal]: [Scope.Debug],
  [AmplitudeEvent.ConditionalFields]: [Scope.Debug],
  [AmplitudeEvent.AddSecondDebtorClicked]: [Scope.Business],
  [AmplitudeEvent.AddSecondDebtorSeen]: [Scope.Business],
  [AmplitudeEvent.RefinancingCalculatorOpen]: [Scope.Business],
  [AmplitudeEvent.RefinancingCalculatorSavingsChange]: [Scope.Business],
  [AmplitudeEvent.UseSaveButton]: [Scope.Business],
  [AmplitudeEvent.DisplayBestOfferBox]: [Scope.Business],
  [AmplitudeEvent.UseCompanyAutocomplete]: [Scope.Business],
  [AmplitudeEvent.ChangeTabVisibility]: [Scope.Debug],
  [AmplitudeEvent.DetectAbort]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.UseHotlineFallback]: [Scope.Business],
  [AmplitudeEvent.ShowHotlineFallback]: [Scope.Debug],
  [AmplitudeEvent.VisitSealUrl]: [Scope.Debug],
  [AmplitudeEvent.AlertSamePayoutAccountUsed]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ShowConstructionFinancingNotice]: [Scope.Business],
  [AmplitudeEvent.CtaIsVisible]: [Scope.Business],
  [AmplitudeEvent.CtaIsClicked]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.BackLinkIsClicked]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.BackButtonIsClicked]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ErrorPageShown]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ErrorOccurred]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDACSuccessAutoRedirect]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDACWithoutClick]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacAccordionClick]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacWrapperView]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacStateChange]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacSuccess]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacAbort]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnDacStepViewAccessConfirmation]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.OnDacStepViewRegistrationSuccessful]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.OnDacTranscationalIdNull]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnLoginClicked]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnTaurineStartsLoading]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnTaurineBecomesUsable]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ParentFrameStartLoadTime]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.FinalAfterInactivityAfterEnteringPayoutAccount]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.FinalAfterInactivityAfterDACInitialization]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.FinalAfterInactivityAfterDACChoice]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.IbanValidated]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.AccountNumberValidated]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.BankCodeValidated]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.RemainingAmountErrorShown]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.OnNewsletterConsentLinkClicked]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.OnBedingungenClickedInVoucher]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.TopNotActivatedVoucherBannerClicked]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.BrandSource]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.PreviousPageErrorNavigationShown]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.PreviousPageErrorNavigationClicked]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.RceEditUpdateDataClicked]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.TplManuallyAdaptedAmountRelation]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.Tpl3AmountRelation]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaInitiated]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaSkipped]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaGetStatus]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaGetStatusError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaStatusIsValid]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaPostToken]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaPostTokenSuccess]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaPostTokenError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaChallengeStarted]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaWidgetLoaded]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaUnsupported]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaSuccess]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaExecute]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaExecuteError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaExecuteSuccess]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaChallengeSuccess]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaKillSwitchIsActive]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaExpired]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaTimeout]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaBeforeInteractive]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaAfterInteractive]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaAlreadyInProgress]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaTimeoutError]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.CaptchaAborted]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.ResumeHashConsumed]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.NudgeIsVisible]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.DesiredPayoutTime]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.AgeGroup]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.IncomeSetSuccessfully]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.StartDacButtonClicked]: [Scope.Business],
  [AmplitudeEvent.MoreInfoDacClicked]: [Scope.Business],
  [AmplitudeEvent.ValidationErrorOccured]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.RceEditStreetChanged]: [Scope.Business],
  [AmplitudeEvent.RceEditStreetNumberChanged]: [Scope.Business],
  [AmplitudeEvent.RceEditIbanChanged]: [Scope.Business],
  [AmplitudeEvent.RceEditAmountChanged]: [Scope.Business],
  [AmplitudeEvent.RceEditIncomeChanged]: [Scope.Business],
  [AmplitudeEvent.RceEditPensionChanged]: [Scope.Business],
  [AmplitudeEvent.AddToVoucherCampaign]: [Scope.Business],
  [AmplitudeEvent.RequestedAmountBetween20k50k]: [Scope.Business],
  [AmplitudeEvent.RequestedAmountBetween30k50k]: [Scope.Business],
  [AmplitudeEvent.RequestedAmountOver50k]: [Scope.Business],
  [AmplitudeEvent.AddedAdditionalNationality]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.RemovedAdditionalNationalities]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.IsMultipleCitizenshipAddedOnFinal]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.FieldResetOnError]: [Scope.Debug],
  [AmplitudeEvent.DocumentDeliveryOptionMissing]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.DocumentDeliveryChangeLinkClicked]: [
    Scope.Business,
    Scope.Debug
  ],
  [AmplitudeEvent.DocumentDeliveryChoiceMissing]: [Scope.Business, Scope.Debug],
  [AmplitudeEvent.DocumentDeliverySelection]: [Scope.Business, Scope.Debug]
}

export enum PathToTracking {
  '/common/payoutAccount/iban' = AmplitudeEvent.IbanValidated,
  '/common/payoutAccount/accountNumber' = AmplitudeEvent.AccountNumberValidated,
  '/common/payoutAccount/bankCode' = AmplitudeEvent.BankCodeValidated,
  '/debtors/primary/income/primary' = AmplitudeEvent.IncomeSetSuccessfully
}

// after the AB test check if these fields are still relevant for tracking and if yes we can move this to a more generic place
export const successTrackableFields = [
  '/common/payoutAccount/iban',
  '/common/payoutAccount/accountNumber',
  '/common/payoutAccount/bankCode',
  '/debtors/primary/income/primary'
]

export function getScope(event: AmplitudeEvent): Scope[] {
  return scope[event]
}
